import { render } from "./MobPromotionView.vue?vue&type=template&id=12f46797&scoped=true"
import script from "./MobPromotionView.vue?vue&type=script&lang=js"
export * from "./MobPromotionView.vue?vue&type=script&lang=js"

import "./MobPromotionView.vue?vue&type=style&index=0&id=12f46797&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f46797"]])

export default __exports__